export const getFileInfo = async (file: File) => {
  const { filetypeinfo } = await import('magic-bytes.js');

  const buff = await file.arrayBuffer();
  const uintArray = new Uint8Array(buff.slice(0, 262));

  return filetypeinfo(uintArray)[0];
};
